import React from 'react';
import { Paper, PaperProps } from '@mui/material';
import { borderRadiusValues } from 'shared/lib/utils/uiConstants';
import IconFile from 'shared/icons/iconFile';

export default function NoPreviewPlug({ sx, ...other }: PaperProps) {
  return (
    <Paper
      elevation={4}
      {...other}
      sx={{
        display: 'flex',
        flexShrink: 0,
        p: 15,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: borderRadiusValues.XSmall,
        alignSelf: 'stretch',
        ...sx,
      }}
    >
      <IconFile></IconFile>
    </Paper>
  );
}
